import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { CommandPalette } from './CommandPalette';
import { QuickCreateMenu } from './QuickCreateMenu';
import { NotificationsMenu } from './NotificationsMenu';
import { ThemeControls } from './ThemeControls';
import { UserMenu } from './UserMenu';
import { useUiStore } from '@/store/uiStore';

/** Top application bar: menu toggle, global search, quick-create, alerts, account. */
export function Topbar() {
  const setSidebarMobileOpen = useUiStore((s) => s.setSidebarMobileOpen);

  return (
    <AppBar position="sticky" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
      <Toolbar sx={{ gap: 1 }}>
        <IconButton
          edge="start"
          onClick={() => setSidebarMobileOpen(true)}
          aria-label="Open navigation"
          sx={{ display: { lg: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        <CommandPalette />

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.5} alignItems="center">
          <QuickCreateMenu />
          <NotificationsMenu />
          <ThemeControls />
          <UserMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
